import React, { memo } from "react";
import PropTypes from "prop-types";
import { snakeCase } from "lodash";
import Tooltip from "react-bootstrap/Tooltip";
import Button from "react-bootstrap/Button";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Icon from "../../../components/Icon";

const OVERLAY_PLACEMENT = {
  BOTTOM: "bottom"
};

const TooltipButton = ({ onClick, label, type, disabled, accessKey }) => (
  <OverlayTrigger
    overlay={
      <Tooltip
        id="header-warning-tooltip"
        data-testid={`global_search_btn_${snakeCase(type)}_tooltip`}
      >
        {label}
      </Tooltip>
    }
    placement={OVERLAY_PLACEMENT.BOTTOM}
    // hack to prevent react-bootstrap console warnings about needing to have hover and focus trigger
    trigger={["hover", "hover"]}
  >
    <div
      className={`search__button-container ${
        disabled ? "search__button-container--disabled" : ""
      }`}
    >
      <Button
        id={`global-search-btn-${type}`}
        data-testid={`global_search_btn_${snakeCase(type)}`}
        variant="link"
        className={`search__button ${disabled ? "disabled" : ""}`}
        onClick={onClick}
        disabled={disabled}
        accessKey={accessKey}
      >
        <Icon name={type} />
      </Button>
    </div>
  </OverlayTrigger>
);

TooltipButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  accessKey: PropTypes.string
};

export default memo(TooltipButton);
